


export const generateSectionId = (sectionName, sections) => {
    const info = parseInfo(sectionName)
    //Strip spaces and special characters
    const id = sectionName.replaceAll(/\s/g, '').replaceAll(/\W/g,"");
    const idInUse = sections.map(section => section.sectionId).includes(id)
    if (idInUse) {
        return generateSectionId(info.curName + info.newTail, sections)
    } else {
        return id
    }
}

export const generateFieldId = (fieldName, sections) => {
    const info = parseInfo(fieldName)
    //Strip spaces and special characters
    const fieldId = fieldName.replaceAll(/\s/g, '_').replaceAll(/\W/g,"");
    const fieldIdInUse = sections.flatMap(section => section.fields).filter(field => field.fieldId == fieldId).length > 0
    if (fieldIdInUse) {
        return generateFieldId(info.curName + info.newTail, sections)
    } else {
        return fieldId
    }
}

const parseInfo = (name) => {
    //Does it end with _1, _2 etc
    const match = name.toString().match(/_\d+(\.\d+)?$/)
    //Get the tail from the match or return an empty string
    const curTail = match ? match[0] : ""
    //Calculate the current number on the tail
    const curNum  = curTail ? parseInt(curTail.substr(1,match[0].length)) : 0
    //Calculate the name minus the tail
    const curName = name.toString().substr(0, name.toString().length - curTail.length)
    const newTail = curNum ? '_' + (curNum + 1) : "_2"
    return {"curTail": curTail, "curNum": curNum, "curName": curName, "newTail": newTail}
}
